import { ws } from "../../../utils/common";

export const getDetailsEventWS = async ({ id }) => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "event/" + id,
    { all: true },
    null,
    true
  );

  if (res.error) {
    throw res.data.title;
  } else {
    return res.data;
  }
};

export const getAllTopicWS = async () => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "topic/",
    null,
    null,
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};

export const getEventTypeWS = async () => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "event-type/",
    null,
    null,
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};

export const postEventWS = async ({ body, formData }) => {
  //CARICO L'EVENTO
  const res = await ws(
    "POST",
    process.env.REACT_APP_ENDPOINT + "event/",
    null,
    body,
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    //Se tutto è andato a buon fine, carico l'immagine dell'evento
    const id_event = res.data.id_event;
    const res2 = await ws(
      "POST",
      process.env.REACT_APP_ENDPOINT + "photo-event/" + id_event.toString(),
      null,
      formData,
      true
    );

    if (res2.error) {
      throw res2.data;
    } else {
      //Rispondo cone evento creato
      return res.data.message;
    }
  }
};

export const putEventWS = async ({ body, formData, idEvent }) => {
  //CARICO L'EVENTO
  const res = await ws(
    "PUT",
    process.env.REACT_APP_ENDPOINT + "event/" + idEvent,
    null,
    body,
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    //Se tutto è andato a buon fine, carico l'immagine dell'evento
    const res2 = await ws(
      "POST",
      process.env.REACT_APP_ENDPOINT + "photo-event/" + idEvent,
      null,
      formData,
      true
    );

    if (res2.error) {
      throw res2.data;
    } else {
      //Rispondo con evento modificato
      return res.data.message;
    }
  }
};
